import {
  BiDashboardGrantInput,
  BiDashboardGrantPermission,
  BiDashboardVisibility,
} from '@euler/model/bi/dashboard';
import { kBiGrantLabels } from '../../../functions/biDashboardText';

export interface BiAudienceLine {
  who: string;
  can: string;
}

/**
 * Who reaches the dashboard under a visibility and grants, as the confirm
 * step lists it: the owner, the whole store when it is store-visible, and
 * each grantee with what they may do.
 */
export function biAudienceLines(
  visibility: BiDashboardVisibility,
  grants: BiDashboardGrantInput[],
  nameOf: (memberId: number) => string,
  /** Members of the store, when known. */
  storeMembers: number | null,
): BiAudienceLine[] {
  const lines: BiAudienceLine[] = [{ who: '你', can: '所有者' }];
  if (visibility === BiDashboardVisibility.Store)
    lines.push({
      who:
        storeMembers === null
          ? '门店所有成员'
          : `门店所有成员（${storeMembers} 人）`,
      can: kBiGrantLabels[BiDashboardGrantPermission.View],
    });
  for (const grant of grants) {
    // A view grant adds nothing for a store-visible dashboard's members.
    if (
      visibility === BiDashboardVisibility.Store &&
      grant.permission === BiDashboardGrantPermission.View
    )
      continue;
    lines.push({
      who: nameOf(grant.memberId),
      can: kBiGrantLabels[grant.permission],
    });
  }
  return lines;
}

/** Same grantees with the same permissions, in any order. */
export function biSameGrants(
  a: BiDashboardGrantInput[],
  b: BiDashboardGrantInput[],
): boolean {
  if (a.length !== b.length) return false;
  const permissions = new Map(
    a.map(grant => [grant.memberId, grant.permission]),
  );
  return b.every(grant => permissions.get(grant.memberId) === grant.permission);
}
